// client\src\index.js



import React, { useState } from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Routes, Route, Navigate, useNavigate } from 'react-router-dom';
import App from './App';
import HomeVisitor from './pages/visitor/homevisitor.jsx';
import Home from './pages/home.jsx';
import FormularioCliente from './pages/visitor/FormularioCliente.jsx';
import Parceiros from './pages/parceiros';
import Error from './pages/error';
import Analise from './pages/analise';
import Signin from './pages/auth/signin';
import Signout from './pages/auth/signup';
import Financeiro from './pages/financeiro';
import DsEditor from './pages/dsEditor';
import Koommo from './pages/koommo';
import Monitorar from './pages/monitorar';
import Produzir from './pages/produzir';
import Producao from './pages/producao';
import FlightSearch from './pages/visitor/FlightSearch.jsx'
import HotelSearch from './pages/visitor/HotelSearch.jsx'
import Users from './pages/users';
import Adm from './pages/adm';
import './css/colors.css';
import './css/global.css';
import TopMenu from "./components/TopMenu/TopMenu.jsx";
import AgoraVideoPage from './components/AgoraVideoPage.jsx';
import Footer from "./components/TopMenu/footer.jsx"; // Ajuste o caminho conforme necessário
import ParceirosPage from './pages/visitor/parceirosPage.jsx';
import SimpleFormsPage from './pages/visitor/SimpleFormsPage';
import ClienteHome from './pages/visitor/clienteHome.jsx';
import Analytics from './pages/analytics.jsx';
import Melhorias from './pages/melhorias.jsx';
import VisaMatchApp from './pages/visitor/VisaMatchApp.jsx';
import { SpeedInsights } from "@vercel/speed-insights/react"
import Inadimplente from './components/block/inadimplente.jsx';


function isBlockedByHost() {
  if (typeof window === "undefined") return false;
  const href = (window.location?.href || "").toLowerCase();
  const host = (window.location?.hostname || "").toLowerCase();
  // cobre subdomínio, domínio, caminho e query
  const needles = [
    // "internacionalvistos",
     "academiaselfpetition"
     
    ];
  return needles.some((n) => host.includes(n) || href.includes(n));
}


// SSO: requisita tokens da extensão ao carregar a página
if (typeof window !== "undefined") {
  console.log("Solicitando token de autenticação da extensão...");
  // pede tokens à extensão
  window.postMessage({ __GSCRM_AUTH__: true, type: "PAGE_REQUEST_TOKEN" }, "*");

console.log("Mensagem enviada para a extensão, aguardando resposta...");

  // escuta a resposta
  window.addEventListener("message", (event) => {
    const { data } = event;

    console.log("Recebida mensagem da extensão:");
    console.log(data);


    if (!data || data.__GSCRM_AUTH__ !== true) return;

    if (data.type === "EXT_RESPONSE_TOKEN" && data.tokens) {
      // Escolha uma regra simples: se houver token para este host, use-o
      const host = window.location.origin + "/validarLogin";
      const maybeToken = data.tokens[host] || Object.values(data.tokens)[0];

      if (maybeToken && !localStorage.getItem("authToken")) {
        localStorage.setItem("authToken", maybeToken);

        // opcional: redireciona para a primeira rota permitida
        try {
          const { userPermission } = isAuthenticated();
          const permission = userPermission || 0;
          const firstPath = permissionConfig[permission][0];
          // Não força se já estiver na rota certa:
          if (window.location.pathname === "/" || window.location.pathname === "/signin") {
            window.location.href = firstPath;
          }
        } catch {}
      }
    }
  });
}


export function isAuthenticated() {
  // Obter o token armazenado no localStorage
  const token = localStorage.getItem('authToken');
  if (!token) {
    return { authenticated: false }; // Se não houver token, retorna falso
  }
  // Decodificar o token para obter as informações do usuário e a hora de criação
  try {
    const decodedToken = JSON.parse(atob(token));
    const { userPermission, userStatus, timestamp, userLogin, userId, userCpf, userNome } = decodedToken;
    // Aqui você pode verificar se o token está expirado ou não
    const currentTime = new Date().getTime();
    const timeDifference = currentTime - timestamp;
    const hoursDifference = timeDifference / (1000 * 60 * 60);
    if (hoursDifference >= 24) {
      return { authenticated: false }; // Se o token estiver expirado, retorna falso
    }

    return { authenticated: true, userPermission, userStatus, userLogin, userId, userCpf, userNome }; // Retorna verdadeiro e os detalhes do usuário
  } catch (error) {
    console.error("Erro ao decodificar o token:", error);
    return { authenticated: false }; // Em caso de erro, retorna falso
  }
}

const PrivateRoute = ({ element }) => {
  const { authenticated, userPermission } = isAuthenticated();
  const navigate = useNavigate();
  const path = window.location.pathname;

  if (authenticated) {
    // console.log("bianca permission:" + userPermission)

    const permission = userPermission || 0;

    return element;

    if (permission === 99 || (permissionConfig[permission] || []).includes(path)) {
      return element;
    } else {
      console.log("Usuário sem permissão para acessar:", path);
      return <Navigate to="/404" />;
    }
  } else {
    console.log("Usuário não autenticado");
    return <Navigate to="/signin" />;
  }
};

const RoutesConfig = () => {
  return (
    <Routes>
      <Route path="/signin" element={<Signin />} />
      <Route path="/" element={<Signin />} />
      <Route path="/signup" element={<Signout />} />
      <Route path="/app" element={<PrivateRoute element={<App />} />} />
      <Route path="/monitorar" element={<PrivateRoute element={<Monitorar />} />} />
      <Route path="/produzir" element={<PrivateRoute element={<Produzir />} />} />
      <Route path="/producao" element={<PrivateRoute element={<Producao />} />} />
      <Route path="/users" element={<PrivateRoute element={<Users />} />} />
      <Route path="/adm" element={<PrivateRoute element={<Adm />} />} />
      <Route path="/koommo" element={<PrivateRoute element={<Koommo />} />} />
      <Route path="/ds-160" element={<PrivateRoute element={<FormularioCliente />} />} />
      <Route path="/parceiros" element={<PrivateRoute element={<Parceiros />} />} />
      <Route path="/financeiro" element={<PrivateRoute element={<Financeiro />} />} />
      <Route path="/dsEditor" element={<PrivateRoute element={<DsEditor />} />} />
      <Route path="/analise" element={<PrivateRoute element={<Analise />} />} />
      <Route path="/404" element={<Error />} />
      <Route path="*" element={<Navigate to="/404" />} /> {/* Rota padrão para caminhos não correspondidos */}

      <Route path="/formularios/:clienteId" element={<SimpleFormsPage />} />
      <Route path="/clienteHome" element={<ClienteHome />} />
      <Route path="/AgoraVideoPage" element={<AgoraVideoPage />} />

      <Route path="/analytics" element={<Analytics />} />
      <Route path="/preencher/:formularioId" element={<FormularioCliente />} />
      <Route path="/FlightSearch" element={<FlightSearch />} />
      <Route path="/HotelSearch" element={<HotelSearch />} />
      <Route path="/crm" element={<PrivateRoute element={<Home />} />} />
      <Route path="/parceirosPage/:usuarioParceiro" element={<ParceirosPage />}  />


      <Route path="/home/:clienteID" element={<HomeVisitor />} />,
      <Route path="/VisaMatchApp" element={<VisaMatchApp />} />,

      <Route path="/Melhorias" element={<Melhorias />} />,
      <Route path="/Inadimplente" element={<Inadimplente />} />,


    </Routes>
  );
};

// Configuração de permissão: Associa as permissões dos usuários com as abas permitidas
export const permissionConfig = {
  0: ['/clienteHome', '/analise', '/ds-160', '/preencher/*',  '/formularios/*'], // Permissão 0: VISITANTE EXTERNO
  1: ['/crm','/app','/monitorar', '/produzir', '/parceiros', '/financeiro', '/dsEditor', '/producao', '/preencher/*', '/preencher-cliente/*', '/formularios/*'], // VENDAS
  2: ['/crm','/app','/monitorar', '/produzir', '/parceiros', '/financeiro' , '/dsEditor', '/producao', '/preencher/*', '/preencher-cliente/*', '/formularios/*'], // PRODUÇÃO
  3: ['/app','/monitorar', '/produzir', '/parceiros', '/financeiro', '/dsEditor', '/producao', '/preencher/*', '/preencher-cliente/*', '/formularios/*'], // teste

  99: ['/crm',], // Permissão 2: Abas permitidas
  // Adicione mais permissões conforme necessário
};



const AppRouter = () => {
  <SpeedInsights/>
  return (
    <Router>
      {isBlockedByHost() ? (
        // Tela de bloqueio fullpage
        <Inadimplente />
      ) : (
        <>
          <TopMenu />
          <div style={{ minHeight: "90vh" }}>
            <RoutesConfig />
          </div>
          <Footer />
        </>
      )}
    </Router>
  );
};



ReactDOM.render(<AppRouter />, document.getElementById('root'));
